<template>
  <div ref="imageWrapper" class="w-full" :class="{'h-full': wrapperHFull}">
    <blur-hash-canvas v-show="hash" :hash="hash" :width="width" :height="height" ref="blurImage" class="duration-200 opacity-100" :class="imgClass" />
    <img :src="imgSrc" ref="image" class="hidden w-full duration-200 opacity-0" :class="imgClass" />
  </div>
</template>

<script>
  export default {
    name: 't-img',
    props: {
      imgSrc: {
        type: String,
        required: true
      },
      hash: {
        type: String || null,
        required: true
      },
      aspectRatio: {
        type: String,
        required: false,
        default: '200:150' // Default is 4/3
      },
      imgClass: {
        type: String
      }
    },
    data() {
      return {
        width: 200,
        height: 150
      }
    },
    async mounted() {
      await this.componentInit()
      this.calcSizes()
      await this.componentLoad()
      Promise.all([this.$refs.image.isLoaded()]).then(() => {
        this.$refs.blurImage.$el.classList.replace(['opacity-100'], ['opacity-0'])
        setTimeout(() => {
          this.$refs.blurImage.$el.classList.add('hidden')
          this.$refs.image.classList.remove('hidden')
          this.$refs.image.classList.replace(['opacity-0'], ['opacity-100'])
        }, 200)
      })
    },
    computed: {
      wrapperHFull() {
        return this.imgClass && /h-full/g.test(this.imgClass)
      }
    },
    methods: {
      calcSizes() {
        const heightDelta = this.aspectRatio.split(':')[0] / this.aspectRatio.split(':')[1]
        this.width = this.$refs.imageWrapper.clientWidth
        this.height = Math.floor(this.width / heightDelta)
      },
      componentInit() {
        return new Promise(resolve => {
          const interval = setInterval(() => {
            if (this.$refs.imageWrapper) {
              clearInterval(interval)
              resolve()
            }
          }, 333)
        })
      },
      componentLoad() {
        return new Promise(resolve => {
          const interval = setInterval(() => {
            if (this.$refs.imageWrapper && this.$refs.image && this.$refs.blurImage) {
              clearInterval(interval)
              resolve()
            }
          }, 333)
        })
      }
    }
  }
</script>
